import { baseApiUrl, getHttpHeaders } from "./ApiUtils";
import axios from "axios";
import {
  saveUserProfileFromToken,
  clearUserProfile,
} from "../utils/userProfileUtils";

export const tokenKey = "adn.mgm.token";
export const refreshTokenKey = "adn.mgm.refreshtoken";
export const expirationKey = "adn.mgm.expiration";

export function parseJwt(token) {
  let base64Url = token.split(".")[1];
  let base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  let jsonPayload = decodeURIComponent(
    atob(base64)
      .split("")
      .map(function (c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join("")
  );

  return JSON.parse(jsonPayload);
}

export function tokenHasExpired() {
  let token = localStorage.getItem(tokenKey);
  if (token) {
    let jwt = parseJwt(token);
    let current_time = new Date().getTime() / 1000;
    if (current_time > jwt.exp) {
      return true;
    }
  }
  return false;
}

export async function getNewToken() {
  const baseUrl = `${baseApiUrl}/api/Auth/refresh-token`;
  let config = getHttpHeaders();
  const token = localStorage.getItem(tokenKey);
  const refreshToken = localStorage.getItem(refreshTokenKey);
  const tokens = { token, refreshToken };
  let data = JSON.stringify(tokens);

  return await axios.post(baseUrl, data, config);
}

let refreshPromise;

export function expireToken() {
  refreshPromise = undefined;
}

export async function getAccessToken() {
  if (refreshPromise) {
    return refreshPromise;
  } else {
    refreshPromise = new Promise(async (resolve, reject) => {
      await getNewToken()
        .then((response) => {
          if (response.status === 200) {
            localStorage.setItem(tokenKey, response.data.token);
            localStorage.setItem(refreshTokenKey, response.data.refreshToken);
            localStorage.setItem(expirationKey, response.data.expiration);
            saveUserProfileFromToken(response.data.token);
            expireToken();
            resolve(response.data);
          } else {
            expireToken();
            reject(response);
            localStorage.removeItem(tokenKey);
            localStorage.removeItem(refreshTokenKey);
            localStorage.removeItem(expirationKey);
            clearUserProfile();
            window.location.href = "/login";
          }
        })
        .catch((err) => {
          expireToken();
          reject(err);
          localStorage.removeItem(tokenKey);
          localStorage.removeItem(refreshTokenKey);
          localStorage.removeItem(expirationKey);
          clearUserProfile();
          window.location.href = "/login";
        });
    });

    return refreshPromise;
  }
}
